import { render, staticRenderFns } from "./r-datepicker.vue?vue&type=template&id=52dc7022&"
import script from "./r-datepicker.vue?vue&type=script&lang=js&"
export * from "./r-datepicker.vue?vue&type=script&lang=js&"
import style0 from "./r-datepicker.vue?vue&type=style&index=0&id=52dc7022&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports